<script setup lang="ts">
import Icon from '@components/Icon.vue';
import Typography from '@components/Typography.vue';
import { IconCheck } from '@icons';

interface InputTagProps {
  value: string;
  active?: boolean;
}

const { active = false } = defineProps<InputTagProps>();

defineEmits<{(e: 'update:tag', value: string): void }>();
</script>

<template>
  <button
    type="button"
    class="checkable-tag"
    :class="[
      'flex items-center justify-between gap-x-4',
      'h-10 w-full p-3',
      'rounded-lg',
      'hover:bg-gray-lighter',
      'cursor-pointer',
      'border border-solid border-gray',
      { '!border-blue !bg-blue-lighter': active }
    ]"
    @click.stop="$emit('update:tag', value)"
  >
    <Typography
      variant="small-title-tag"
      :color="active ? 'blue' : 'black'"
      class="flex items-center gap-x-2 whitespace-nowrap"
    >
      <slot />
    </Typography>

    <Icon
      v-if="active"
      :svg="IconCheck"
      width="20"
      height="20"
      fill="blue"
    />

    <span v-else class="size-5" />
  </button>
</template>
